import { compose } from "redux";
import { connect } from "react-redux";
import { withFormik } from "formik";

import mapStateToProps from "./structured-selectors";
import { emailSet } from "../../ducks/user";
import { createSignUpValidationSchema } from "./validationSchema";

import { IFormValues, ISignUpProps } from "./types";

const mapDispatchToProps = {
  saveEmailToState: emailSet,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withFormikConnect = withFormik<ISignUpProps, IFormValues>({
  validationSchema: (props: ISignUpProps) => createSignUpValidationSchema(props.required),
  validateOnChange: true,
  handleSubmit: () => null,
});

export const enhance = compose(withConnect, withFormikConnect);
